import { Download } from '@mui/icons-material';
import { Button, Tooltip } from '@mui/material';
import { MyFleetCsvHeaders } from '../../../../models/my-fleet.model';
import DownloadHelpers from '../../../../utils/download.utils';

export default function MyFleetCsvTemplateDownload() {
  const csvContent = `${MyFleetCsvHeaders.Ship},${MyFleetCsvHeaders.IMO},${MyFleetCsvHeaders.VesselContactEmails},${MyFleetCsvHeaders.ShoreContactEmails}\nVessel name 1,1234567,email1@example.com,shore1@example.com\nVessel name 2,2345678,"email'2@example.com,email'22@example.com",shore2@example.com\nVessel name 3,3456789,email3@example.com,"shore3@example.com, shore33@example.com"`;

  const blobUrl = DownloadHelpers.createDownloadLink(csvContent, 'text/csv');

  const handleDownload = (e: React.MouseEvent) => {
    e.preventDefault();
    DownloadHelpers.downloadURI('my_fleet_template.csv', blobUrl);
  };

  return (
    <Tooltip title="Download CSV template with example data">
      <Button
        sx={{ marginBottom: '1rem' }}
        onClick={handleDownload}
        startIcon={<Download />}
        data-testid="download-csv-template-button"
      >
        Download Excel template
      </Button>
    </Tooltip>
  );
}
